import type { ReactNode } from 'react';

import type { ChartDatapoint } from '../../../core/types/chart-data.js';
import type { XYChartTooltipPayload } from '../../../xy-chart/types/xy-chart.js';
import { FLAME_ORIGINAL_IDX } from '../constants.js';
import type { CustomTooltipTemplate } from '../types/flame-internal.js';

export const resolveFlameTooltipContent = <TData extends ChartDatapoint>(
  payload: XYChartTooltipPayload,
  originalData: readonly TData[],
  customTooltipTemplate: CustomTooltipTemplate<TData> | undefined,
  renderDefaultTooltip: (datapoint: TData) => ReactNode,
): ReactNode => {
  const transformedDatapoint = payload.rectPayload?.datapoint as
    | TData
    | undefined;

  if (!transformedDatapoint) {
    return;
  }

  const originalIdx = transformedDatapoint[FLAME_ORIGINAL_IDX] as number;
  const originalDatapoint = originalData[originalIdx];

  if (customTooltipTemplate) {
    const template = customTooltipTemplate({
      ...payload.rectPayload,
      datapoint: originalDatapoint,
    });

    if (template === null) {
      return null;
    }
    if (template) {
      return template;
    }
  }

  return renderDefaultTooltip(originalDatapoint);
};
